import AccountManagerSummary from './AccountManagerSummary';

export default AccountManagerSummary;
